export default __webpack_public_path__ + "2db1ea6fb7bf92cfb8b605f317b90af4.svg";